import React from "react";
import { Routes, Route } from "react-router-dom";

import NCPLayout from "./NCPLayout";
import Home from "../Pages/Home/Home";
import AboutUs from "../Pages/AboutUs/AboutUs";
import Founder from "../Pages/AboutUs/Founder";
import OurBoard from "../Pages/OurBoard";
import Coreteam from "../Pages/AboutUs/CoreTeam";
import Publications from "../Pages/Publications/Publications";
import Donate from "../Pages/Donate"; 
// , Navigate, useLocation,useNavigate
// import Login from "../Pages/Login/Login";
import ContactUs from "../Pages/ContactUs";
const NCPRoutes = () => {
    return (<>
   <Routes>
        {/* Below is for home pages routes */}
        <Route path="/" element={<NCPLayout />}>
          <Route index element={<Home />} />
           <Route path="/AboutUs" element={<AboutUs />} />
          <Route path="/Founder" element={<Founder />} />
           <Route path="/Coreteam" element={<Coreteam />} />
           <Route path="/Our Board" element={<OurBoard />} />
          <Route path="/Publications" element={<Publications />} />
          <Route path="/Donate" element={<Donate />} />
          {/* <Route path="/AnnualReports" element={<AnnualReports />} /> */}
          <Route path="/Contact Us" element={<ContactUs />} />
          {/* <Route path="/Login" element={<Login />} />  */}
        </Route>
        </Routes>
    </>)
}

export default NCPRoutes;